import type { BrowserSafeMerchantProduct } from '@/types'

export const demoInventory: BrowserSafeMerchantProduct[] = [
	{
		id: 1,
		name: 'Sourdough Loaf',
		description: 'Traditional 24-hour fermented sourdough bread, 800g',
		priceInMinorUnits: 385,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 2,
		name: 'White Farmhouse Loaf',
		description: 'Classic white bread loaf, 700g',
		priceInMinorUnits: 225,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 3,
		name: 'Wholemeal Loaf',
		description: 'Nutritious wholemeal bread, 800g',
		priceInMinorUnits: 275,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 4,
		name: 'Baguette',
		description: 'Crusty French-style baguette, 250g',
		priceInMinorUnits: 195,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 5,
		name: 'Croissant',
		description: 'Buttery French-style croissant',
		priceInMinorUnits: 145,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 6,
		name: 'Pain au Chocolat',
		description: 'Chocolate-filled French pastry',
		priceInMinorUnits: 165,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 7,
		name: 'Cinnamon Swirl',
		description: 'Danish pastry with cinnamon filling',
		priceInMinorUnits: 195,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 8,
		name: 'Olive Focaccia',
		description: 'Italian flatbread with olives and rosemary, 400g',
		priceInMinorUnits: 345,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 9,
		name: 'Seeded Bagel',
		description: 'Traditional bagel with mixed seeds',
		priceInMinorUnits: 125,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 11,
		name: 'Hot Cross Bun',
		description: 'Traditional spiced sweet bun with dried fruit',
		priceInMinorUnits: 125,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 12,
		name: 'Chocolate Brownie',
		description: 'Rich Belgian chocolate brownie',
		priceInMinorUnits: 245,
		customVat: 20,
		deletedAt: null,
	},
	{
		id: 13,
		name: 'Victoria Sponge Slice',
		description: 'Classic sponge with jam and buttercream',
		priceInMinorUnits: 285,
		customVat: 20,
		deletedAt: null,
	},
	{
		id: 14,
		name: 'Artisan Rye Bread',
		description: 'Dark rye sourdough bread, 500g',
		priceInMinorUnits: 350,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 15,
		name: 'Raspberry Danish',
		description: 'Pastry with raspberry jam and icing',
		priceInMinorUnits: 195,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 16,
		name: 'Cheese Scone',
		description: 'Savory scone with mature cheddar',
		priceInMinorUnits: 155,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 17,
		name: 'Fruit Scone',
		description: 'Traditional scone with sultanas',
		priceInMinorUnits: 145,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 18,
		name: 'Sausage Roll',
		description: 'Buttery pastry with seasoned pork filling',
		priceInMinorUnits: 180,
		customVat: 20,
		deletedAt: null,
	},
	{
		id: 19,
		name: 'Salted Caramel Cake Slice',
		description: 'Indulgent cake with salted caramel layers',
		priceInMinorUnits: 295,
		customVat: 20,
		deletedAt: null,
	},
	{
		id: 20,
		name: 'Gluten-Free Bread',
		description: 'Mixed seed gluten-free loaf, 400g',
		priceInMinorUnits: 395,
		customVat: 0,
		deletedAt: null,
	},
]

export const floristInventory: BrowserSafeMerchantProduct[] = [
	{
		id: 1,
		name: 'Red Roses',
		description: 'Premium long-stem red roses, sold per stem',
		priceInMinorUnits: 450,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 2,
		name: 'White Lilies',
		description: 'Oriental white lilies, 3 stems per bunch',
		priceInMinorUnits: 850,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 3,
		name: 'Seasonal Mixed Bouquet',
		description: "Chef's choice seasonal arrangement, 12 stems",
		priceInMinorUnits: 2450,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 4,
		name: 'White Chrysanthemums',
		description: 'Large white chrysanthemum heads, 5 stems per bunch',
		priceInMinorUnits: 650,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 5,
		name: 'Pink Carnations',
		description: 'Fresh pink carnations, 10 stems per bunch',
		priceInMinorUnits: 580,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 6,
		name: 'Eucalyptus Foliage',
		description: 'Silver dollar eucalyptus branches, 5 stems per bunch',
		priceInMinorUnits: 320,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 7,
		name: 'Yellow Sunflowers',
		description: 'Large sunflower heads, sold per stem',
		priceInMinorUnits: 380,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 8,
		name: 'Purple Irises',
		description: 'Dutch purple irises, 8 stems per bunch',
		priceInMinorUnits: 720,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 9,
		name: 'White Peonies',
		description: 'Seasonal white peonies, 5 stems per bunch',
		priceInMinorUnits: 1250,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 10,
		name: 'Tulips Mixed Colors',
		description: 'Spring tulip mix - red, yellow, pink, 15 stems per bunch',
		priceInMinorUnits: 680,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 11,
		name: 'Purple Orchids',
		description: 'Dendrobium orchid stems, 3 stems per bunch',
		priceInMinorUnits: 1180,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 12,
		name: 'Orange Gerberas',
		description: 'Bright orange gerbera daisies, 6 stems per bunch',
		priceInMinorUnits: 540,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 13,
		name: 'White Hydrangeas',
		description: 'Large white hydrangea heads, 3 stems per bunch',
		priceInMinorUnits: 950,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 14,
		name: 'Lavender Sprigs',
		description: 'Fresh English lavender, 12 sprigs per bunch',
		priceInMinorUnits: 380,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 15,
		name: 'Pink Roses',
		description: 'Blush pink roses, sold per stem',
		priceInMinorUnits: 420,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 16,
		name: 'Blue Delphiniums',
		description: 'Tall blue delphinium spikes, 4 stems per bunch',
		priceInMinorUnits: 780,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 17,
		name: 'White Freesias',
		description: 'Fragrant white freesias, 10 stems per bunch',
		priceInMinorUnits: 650,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 18,
		name: 'Red Gerberas',
		description: 'Bold red gerbera daisies, 6 stems per bunch',
		priceInMinorUnits: 540,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 19,
		name: 'Luxury Orchid Arrangement',
		description: 'White phalaenopsis orchids in ceramic pot',
		priceInMinorUnits: 4250,
		customVat: 20,
		deletedAt: null,
	},
	{
		id: 20,
		name: 'Seasonal Greenery Mix',
		description: 'Mixed foliage - ferns, ivy, eucalyptus, 8 stems',
		priceInMinorUnits: 480,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 21,
		name: 'Bird of Paradise',
		description: 'Exotic strelitzia flowers, sold per stem',
		priceInMinorUnits: 980,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 22,
		name: 'Blue Hyacinths',
		description: 'Fragrant blue hyacinth stems, 6 stems per bunch',
		priceInMinorUnits: 720,
		customVat: 0,
		deletedAt: null,
	},
	{
		id: 23,
		name: 'Yellow Irises',
		description: 'Bright yellow iris stems, 8 stems per bunch',
		priceInMinorUnits: 750,
		customVat: 0,
		deletedAt: null,
	},
]
